/* eslint react/no-danger: 0 */
import React from 'react';
import DOMPurify from 'dompurify';
import firebase from '@/services/firebase';
import useFirebaseDatabaseQuery from '@/hooks/useFirebaseDatabaseQuery';
import ProgressBackdrop from '@/components/ProgressBackdrop';

const QA = () => {
  const dataRef = firebase.database().ref(`/${process.env.REACT_APP_MODE}/pre-order/questionAndAnswer`);
  const { isLoading, data } = useFirebaseDatabaseQuery(dataRef);
  return (
    <>
      <pre dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data, { ADD_ATTR: ['target'] }) }} />
      {isLoading && <ProgressBackdrop isShow />}
    </>
  );
};

export default QA;
